import request from "./request";

//创建文件（包含文件）
export const addFileRow = (params: any, name: string = '', mimeType: string = '') => {
    return request('post', `/api/rubik/file/raw?name=${name}&mimeType=${mimeType}`, params)
}
/**
 *查询获取当公共文档集合。根据文档创建时间倒序排列
 */
export const getLibrary = (params: any) => {
    return request("get", `/api/document/library/common`, params);
};
/**
 *上传公共文档
 */
export const postLibrary = (params: any) => {
    return request("post", `/api/document/library/common`, params);
};
/**
 *使用文档主键删除文档。
 */
export const deleteLibrary = (id: any) => {
    return request("delete", `/api/document/library/common/${id}`);
};
